import { useDebounceFn } from '@vueuse/core'

export const screenSizes = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
  '3xl': 1680,
  '4xl': 1920,
}

const innerWidth = ref(0)
const syncInnerWidth = () => (innerWidth.value = window.innerWidth)

if (typeof window !== 'undefined') {
  syncInnerWidth()
  window.addEventListener('resize', useDebounceFn(syncInnerWidth, 100))
}

export const useDeviceType = () => {
  const { $device } = useNuxtApp()
  const isMobile = useState('is-mobile', () => false)
  const isMobileOrTablet = useState('is-mobile-or-tablet', () => false)
  const isMd = useState('is-md', () => false)
  const isDesktop = useState('is-desktop', () => false)

  if (import.meta.server) {
    isMobile.value = $device.isMobile
    isMobileOrTablet.value = $device.isMobileOrTablet
    isMd.value = $device.isMobile
    isDesktop.value = !$device.isMobile && !$device.isMobileOrTablet
  }

  function update() {
    const width = innerWidth.value
    if (width <= 0) {
      return
    }
    isMobile.value = width < screenSizes.sm
    isMobileOrTablet.value = width < screenSizes.lg
    isMd.value = width < screenSizes.md
    isDesktop.value = width >= screenSizes.lg
  }

  onMounted(update)
  watch(innerWidth, update)


  return { isMobile, isMobileOrTablet, isMd, isDesktop }
}
